<template>
  <v-container class="px-0 pt-0 pb-15" style="max-width: 500px">
    <v-row no-gutters class="text-h4 font-weight-bold px-8 pt-6 pb-2">
      <v-col align-self="center" class="main-font secondary--text"
        >Activity</v-col
      >
    </v-row>
    <Plants />
    <Sharings />
  </v-container>
</template>

<script>
import Plants from "@/components/activity/Plants.vue";
import Sharings from "@/components/activity/Sharings.vue";

export default {
  components: {
    Plants,
    Sharings,
  },
};
</script>
